<!--<button mat-button (click)="expanded = !expanded">Kalkulation {{expanded ? '-' : '+'}}</button>-->
<ng-container *ngIf="expanded">
    <mat-slide-toggle *ngIf="inheritFromChildrenForm" [disabled]="inheritFromChildrenForm.disabled" [checked]="inheritFromChildrenForm.getRawValue()" (change)="onInhritFromChildrenChange($event)">Preis kalkulieren</mat-slide-toggle>
    <h2 class="left-space table-headline">Kosten</h2>
    <div class="arl-container scroll-container">
        <div class="item"></div>
        <div class="item"><h3>Art</h3></div>
        <div class="item"><h3>Menge</h3></div>
        <div class="item"><h3>Einheit</h3></div>
        <div class="item"><h3>Bezeichnung</h3></div>
        <div class="item"><h3>EK</h3></div>
        <div class="item"><h3>Rabatt</h3></div>
        <div class="item"><h3>EK gesamt</h3></div>
        <div class="item"><h3>EK inkl. Vorbew.</h3></div>
        <div class="item"><h3>EK gesamt</h3></div>
        <div class="item"><h3>VK <app-hint-icon hint="Verkaufspreis"></app-hint-icon></h3></div>
        <div class="item"></div>
        <ng-container *ngFor="let arl of arlData$ | async; let i = index">
<!--            todo: Positionen in eigene Komponente auslagern-->
            <div class="item">
                <h3>{{ arl.form.controls?.ItemNumber?.value }}</h3>

            </div>
            <div class="item flex">
                <mat-form-field floatLabel="never">
                    <mat-select [formControl]="arl.form.controls.Type" (selectionChange)="onTypeSelectionChange($event, arl)" placeholder="Art">
                        <mat-option *ngFor="let t of selectableArlTypes" [value]="t.value">{{t.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="theme-override {{ResourcePageMeta.Theme}}" *ngIf="false && arl.form.value.ResourceId">
                    <button mat-icon-button color="primary" [disabled]="_disabled" (click)="onSetEntityId(arl, null)" [matTooltip]="(arl.resource$ | async)?.DisplayName + ' entfernen'"><app-double-icon [Icon]="ResourcePageMeta.Icon" Icon2="link"></app-double-icon></button>
                </div>
            </div>
            <div class="item">
                <mat-form-field floatLabel="never">
<!--                    <input [formControl]="arl.form.controls.Quantity" type="number" matInput placeholder="Menge" />-->
                    <app-calculation-input
                        [maxDecimalPlaces]="AccountsReceivableLedgerEntity.QuantityDecimalPlaces"
                        [formula]="arl.form.controls.QuantityFormula.value"
                        placeholder="Menge"
                        (formulaChange)="arl.form.controls.QuantityFormula.setValue($event); arl.form.controls.QuantityFormula.markAsDirty()"
                        [formulaUsedVariables]="arl.form.controls.QuantityFormulaUsedVariables.value"
                        (formulaUsedVariablesChange)="arl.form.controls.QuantityFormulaUsedVariables.setValue($event); arl.form.controls.QuantityFormulaUsedVariables.markAsDirty()"
                        [useVariables]="true"
                        [formControl]="arl.form.controls.Quantity"
                        (mouseenter)="fixChangeDetection()"
                    ></app-calculation-input>
                </mat-form-field>
            </div>
            <div class="item">
                <mat-form-field floatLabel="never">
                    <mat-select [formControl]="arl.form.controls.QuantityTypeId" placeholder="Einheit" [disabled]="!!forceQuantityTypeIdForEmployeeArls && (arl.type$ | async) === ARLTypeEnum.EmployeeArl">
                        <mat-option *ngFor="let t of arlCalculationDataService.quantityTypes$ | async" [value]="t.Id">{{t.Name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="item flex flex-col">
                <div class="flex">
                    <fa-icon icon="signs-post" *ngIf="arl.form?.value.IsOptional" style="margin-right: 0.5rem;align-self: center;" matTooltip="optional"></fa-icon>
                    <fa-icon icon="slash" *ngIf="arl.form?.value.CrossedOut" style="margin-right: 0.5rem;align-self: center;" matTooltip="gestrichen"></fa-icon>
                    <app-arl-information-input
                        #infoInput
                        style="flex-grow: 1; width: 0;"
                        floatLabel="never"
                        [entityId]="
                            (arl.type$ | async) === ARLTypeEnum.ResourceArl
                                ? arl.form.value.ResourceId
                                : (arl.type$ | async) === ARLTypeEnum.MaterialArl
                                ? arl.form.value.MaterialId
                                : (arl.type$ | async) === ARLTypeEnum.EmployeeArl
                                ? arl.form.value.JobSpecificationId
                                : null"
                        [inputMode]="(arl.type$ | async) === ARLTypeEnum.ResourceArl || (arl.type$ | async) === ARLTypeEnum.MaterialArl || (arl.type$ | async) === ARLTypeEnum.EmployeeArl ? 'pseudoSelectSearch' : 'autocomplete'"
                        [informationControl]="arl.form.controls.Information"
                        [ARLType]="(arl.type$ | async)"
                        (entitySelected)="onSetEntityId(arl, $event?.id, $event?.materialToSupplier)"
                    ></app-arl-information-input>
                </div>

                <div class="flex justify-between items-center form-footer-line" *ngIf="(arl.material$ | async) || (arl.resource$ | async) || (arl.job$ | async)">
                    <div class="clamp-2" *ngIf="arl.material$ | async as material">{{ material.DisplayName }}</div>
                    <div class="clamp-2" *ngIf="arl.resource$ | async as resource">{{ resource.DisplayName }}</div>
                    <div class="clamp-2" *ngIf="arl.job$ | async as jobSpecification">{{ jobSpecification.Name }}</div>
                    <button type="button" mat-icon-button (click)="infoInput.onDropDownSelected(null); onSetEntityId(arl, null, null);"><fa-icon icon="times"></fa-icon></button>
                </div>
            </div>
<!--            EK -->
            <div class="item flex items-center">
                <mat-form-field floatLabel="never"><app-number-transform-input [factor]="1" [formControl]="arl.form.controls.CostAmount" placeholder="EK"></app-number-transform-input></mat-form-field>
                <button *ngIf="(arl.type$ | async) === ARLTypeEnum.MaterialArl" mat-icon-button matTooltip="Preisgestaltung" (click)="onPriceInformationClick(arl)" [disabled]="!arl.form.value.MaterialId || _disabled">
                    <fa-icon icon="info-circle"></fa-icon>
                </button>
            </div>
<!--            Rabatt-->
            <div class="item">
                <mat-form-field floatLabel="never" *ngIf="!isNotNullOrUndefined(arl.form.controls.SurchargeOverride.value)">
                    <app-number-transform-input [factor]="1" [formControl]="arl.form.controls.CostAmountAllowance" placeholder="Rabatt"></app-number-transform-input>
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>
            <div class="item">
<!--                <mat-form-field floatLabel="never"><app-number-transform-input [factor]="1" [formControl]="arl.form.controls.Amount" placeholder="EK gesamt"></app-number-transform-input></mat-form-field>-->
<!--                <mat-form-field floatLabel="never"><input [formControl]="arl.form.controls.Amount" matInput placeholder="EK gesamt" type="number"/></mat-form-field>-->
                {{ arl.costAmountWithoutTaxAndPreChargeByType$ | async | currency: (currencyCode$ | async) }}
            </div>
            <!--        EK inkl. Vorbew.    -->
            <div class="item">{{ arl.pieceCostAmountWithoutTax$ | async | currency: (currencyCode$ | async) }}</div>
            <div class="item">{{ arl.costAmountWithoutTax$ | async | currency: (currencyCode$ | async) }}</div>
            <div class="item">
                <ng-container *ngIf="!isNotNullOrUndefined(arl.form.controls.SurchargeOverride.value)">
                    <button mat-icon-button *ngIf="!arl.form.controls.IndividuallyCostCalculation.value" (click)="onToggleIndividuallyCostCalculation(arl)" matTooltip="VK selbst angeben"><fa-icon icon="pencil-alt"></fa-icon></button>
                    <mat-form-field floatLabel="never" *ngIf="arl.form.controls.IndividuallyCostCalculation.value">
                        <app-number-transform-input [factor]="1" [formControl]="arl.form.controls.BaseCost" placeholder="VK"></app-number-transform-input>
                    </mat-form-field>
                </ng-container>
<!--                {{arl.form.controls?.SurchargeOverride?.value}}-->
            </div>
            <div class="item">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                    <fa-icon icon="ellipsis-vertical"></fa-icon>
                </button>
                <mat-menu #menu>
                    <button mat-menu-item (click)="onToggleOptional(arl)" [disabled]="_disabled">
                        <fa-icon class="mat-icon" icon="signs-post"></fa-icon>
                        <span>{{ arl.form?.value.IsOptional ? 'optional markierung aufheben' : 'als optional markieren'}}</span>
                    </button>
                    <button mat-menu-item (click)="onToggleCrossedOut(arl)" [disabled]="_disabled">
                        <fa-icon class="mat-icon" icon="slash"></fa-icon>
                        <span>{{ arl.form?.value.CrossedOut ? 'durchgestrichen aufheben' : 'durchstreichen'}}</span>
                    </button>
                    <button mat-menu-item (click)="onCopyClick(arl)"  >
                        <fa-icon class="mat-icon"  icon="money-bill"></fa-icon>
                        <span>Position kopieren</span>
                    </button>
                    <button
                        mat-menu-item
                        (click)="onToggleIndividuallyCostCalculation(arl)"
                        *ngIf="!isNotNullOrUndefined(arl.form.controls.SurchargeOverride.value)"
                    >
                        <fa-icon class="mat-icon" icon="percent"></fa-icon>
                        <span>{{ arl.form.value.IndividuallyCostCalculation ? 'VK nicht selbst angeben' : 'VK selbst angeben'}}</span>
                    </button>
                    <button mat-menu-item (click)="removeArl(arl, i)" class="app-foreground-warn" [disabled]="_disabled">
                        <fa-icon class="mat-icon" icon="trash"></fa-icon>
                        <span>löschen</span>
                    </button>
                </mat-menu>
            </div>
        </ng-container>
        <div class="item left-bottom">
            <button mat-button [disabled]="_disabled" (click)="addArl()">+ Kosten hinzufügen</button>
        </div>
        <div class="item right-bottom">
            <strong class="underline">{{amountSum$ | async | currency: (currencyCode$ | async) }}</strong>
        </div>
    </div>
    <h2 class="left-space table-headline">Preis</h2>
    <div class="cost-container left-space">
        <div class="item"><h3>Art</h3></div>
        <div class="item"></div>
        <div class="item"><h3>Summe</h3></div>
        <div class="item"></div>
        <div class="item"><h3>Zuschläge</h3></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"><h3>ZS</h3></div>
        <div class="item"><h3>GZ <app-hint-icon hint="Hier befindet sich der Gesamtzuschlag"></app-hint-icon></h3></div>
        <div class="item"></div>
        <div class="item just-right"><h3>VK gesamt</h3></div>

        <ng-container *ngFor="let z of arlHelper?.zuschlaege">
            <div class="item"><h4>{{z.name}}</h4></div>
            <div class="item"><h3>=</h3></div>
            <div class="item just-right">{{ z.amountSum$ | async | number: '1.2-2' }}</div>
            <div class="item"><h3>+</h3></div>
            <div class="item">
                <mat-form-field floatLabel="never" [appearance]="!z.form.value.usePercent ? 'outline' : undefined">
                    <input [disabled]="_disabled || (z.overrideMode$ | async)" type="number" [ngModel]="z.form.value.decimal" (ngModelChange)="z.settDecimal($event)" matInput placeholder="Zuschläge" />
                </mat-form-field>
            </div>
            <div class="item">
                <mat-form-field floatLabel="never" [appearance]="z.form.value.usePercent ? 'outline' : undefined">
                    <input [disabled]="_disabled || (z.overrideMode$ | async)" type="number" [ngModel]="z.form.value.percent" (ngModelChange)="z.setPercent($event)" matInput placeholder="in %" />
                </mat-form-field>
            </div>
            <div class="item"><h3>%</h3></div>
            <div class="item-inline">
                <span>+</span>
                <span>{{ z.surchargeAddition$ | async | number: '1.2-2' }}</span>
<!--                <span><span>{{ financialRound((z.amountSumWithZuschl$ | async) - ((z.amountSum$ | async)+z.form.value.decimal)) }}</span></span>-->
                <span *ngIf="!(z.overrideMode$ | async)">{{ arlHelper.aRLCalculationPreChargeForAmountCalculation$ | async | percent: '1.2-2' }}</span>
            </div>
            <div class="item" *ngIf="z.amountGZ$ | async as amount; else empty">
                {{ amount | number: '1.2-2' }}%
            </div>

            <ng-template #empty>
                <div class="item"></div>
            </ng-template>
            <div class="item"><h3>=</h3></div>
            <div class="item just-right">{{ z.amountSumWithZuschl$ | async | currency }}<span *ngIf="z.amountSumWithZuschlForIndividuallySurcharge$ | async as fromIndividuals">(+ {{fromIndividuals | currency}} <app-hint-icon hint="von positionen mit selbst gewählten Verkaufspreisen"></app-hint-icon>)</span></div>
        </ng-container>


        <div class="item"><h4>Summe</h4></div>
        <div class="item"><h3>=</h3></div>
        <div class="item just-right"><strong>{{ amountSum$ | async | number: '1.2-2' }}</strong></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item" *ngIf="amountSumGZ$ | async as amount; else empty">
            {{ amount | number: '1.2-2' }}%
        </div>

        <ng-template #empty>
            <div class="item"></div>
        </ng-template>
        <div class="item"></div>
        <div class="item just-right"><strong>{{ amountSumWithZuschl$ | async | currency }}</strong></div>
    </div>
</ng-container>
